<template>
  <div v-if="foundItems !== undefined">
    <form class="a-sort" action="">
      <p class="a-sort__see">
        {{$tc('form.tender-search.search-result', foundItems)}}
      </p>
      <div class="a-sort__block-sort">
        <div class="a-sort__right-block a-sort__right-btn">
          <button class="gui-btn gui-btn--red gui-btn--w-140" style="height: 36px" type="button" @click="exportTendersList">{{$t('buttons.export')}}</button>
        </div>
      </div>
    </form>
    <div class="a-сard-admin">
      <div class="a-сard-admin__block" :class="{'need-attention': tender.needVerify}" v-for="tender in items">
        <div class="a-сard-admin__body">
          <div class="a-сard-admin__content-text">
            <div class="a-сard-admin__label">{{$t('form.tender.owner')}}:</div>
            <p class="a-сard-admin__text">{{tender | fullName}}</p>
          </div>
          <div class="a-сard-admin__content-text">
            <div class="a-сard-admin__label">{{$t('form.tender.tender-status')}}: </div>
            <p class="a-сard-admin__text">{{$t(tender.state.label)}}</p>
          </div>
          <div class="a-сard-admin__content-text">
            <div class="a-сard-admin__label">{{$t('form.tender.tender-name')}}: </div>
            <p class="a-сard-admin__text">{{tender.name}}</p>
          </div>
          <div class="a-сard-admin__content-text">
            <div class="a-сard-admin__label">{{$t('form.tender.tender-number')}}:</div>
            <p class="a-сard-admin__text">{{tender.num}}</p>
          </div>
          <div class="a-сard-admin__content-text">
            <div class="a-сard-admin__label">{{$t('form.tender.number-of-lots-in-tender')}}:</div>
            <p class="a-сard-admin__text">{{tender.countLot}}</p>
          </div>
        </div>
        <div class="a-сard-admin__btn-block">
          <router-link class="gui-btn gui-btn--red gui-btn--large-red-a" :to="{name: 'purchases-tender-details', params: { tenderId: tender.id, tab: 'overview'}}">{{$t('buttons.open-tender')}}</router-link>
        </div>
      </div>
      <button class="gui-btn gui-btn--more u-margin-24-auto" type="button" @click="fetchMoreTenders" v-if="foundItems !== items.length">{{$t('buttons.show-more')}}</button>
    </div>
    <loading v-if="loading"></loading>
  </div>
</template>

<script>
  export default {
    computed: {
      foundItems() { return this.$store.state.search.tenders.total },
      items() { return this.$store.state.search.tenders.items },

      permissions() {
        return this.$store.getters.currentUser.permissions;
      }
    },
    methods: {
      async exportTendersList() {
        await this.$store.dispatch('exportTendersList');
      },

      async fetchMoreTenders() {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('fetchMoreTenders');
          }
          catch(e) {
            console.error('unable to fetch more tenders', e);
            this.globalErrorHandler(e);
          }
        });
      }
    }
  }
</script>

<style scoped>
  .need-attention {
    border: 2px solid #E30613;
  }
</style>
